import { css } from 'lit';
import componentStyles from '../../styles/component.styles.js';
export default css `
    ${componentStyles}

    :host {
        display: block;
    }
`;
//# sourceMappingURL=team-participant-list.styles.js.map